"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publisher = exports.wrappedEventPublisher = void 0;
// Unfortunately this module state must be initialized, since it can't be
// a direct import.
exports.wrappedEventPublisher = null;
exports.publisher = {
    send: function (eventId, eventPayload, key, includeUserId) {
        if (!exports.wrappedEventPublisher) {
            console.error("trying to send event. But the EventPublisher hasn't been registered yet!");
        }
        else {
            exports.wrappedEventPublisher.send(eventId, eventPayload, key, includeUserId);
        }
    },
};
//# sourceMappingURL=EventPublisher.js.map